import { Navigate, Route, useParams } from 'react-router-dom';
import { ACCOUNT_LEGACY_PATH_REDIRECTS } from '@/lib/accountNavigation';

function RedirectOrderDetail() {
  const { orderId } = useParams();
  return <Navigate to={`/account/orders/${orderId}`} replace />;
}

function RedirectOrderTrack() {
  const { orderId } = useParams();
  return <Navigate to={`/account/orders/${orderId}/track`} replace />;
}

/** Legacy shopper account paths → canonical /account/* redirects. */
export function AccountLegacyRoutes() {
  return (
    <>
      {Object.entries(ACCOUNT_LEGACY_PATH_REDIRECTS).map(([from, to]) => (
        <Route key={from} path={from.replace(/^\//, '')} element={<Navigate to={to} replace />} />
      ))}
      <Route path="orders/:orderId" element={<RedirectOrderDetail />} />
      <Route path="orders/:orderId/track" element={<RedirectOrderTrack />} />
    </>
  );
}
